import { Component, OnInit } from '@angular/core';
import { Utils } from '../../utils';

@Component({
  selector: 'cookies-info',
  template: require('./cookies-info.component.html'),
  styles: [require('./cookies-info.component.css')]
})
export class CookiesInfoComponent implements OnInit {

  get accepted()
  {
    return localStorage.getItem('cookiesAccepted') == '1'
  }

  set accepted(v: boolean)
  {
    localStorage.setItem('cookiesAccepted', v? '1': '0');
  }

  get privacyPolicyUrl()
  {
    return location.protocol + '//' + location.host + '/' + 'pt_privacy_policy.pdf';
  }

  constructor() { }

  ngOnInit() {
  }

  openPrivacyPolicy()
  {
    Utils.openPopup(this.privacyPolicyUrl, 'Privacy policy', 750, 550);
  }

}
